<nav aria-label="breadcrumb" (click)="userShowToggle()" *ngIf="user.role != 'manager'">
    <ol class="breadcrumb section-header-breadcrumb">
      <li class="breadcrumb-item active" aria-current="page">
        <div class="breadcrumb-content">
        <i class="fa fa-plus breadcrumb-icon"  *ngIf="!isUserShow"></i>
        <i class="fa fa-minus breadcrumb-icon"  *ngIf="isUserShow"></i>
        <p class="h5 breadcrumb-text"> User Details</p>
    </div></li>
    </ol>
  </nav>
 
<div *ngIf = "isUserShow">
<a routerLink="add" class="btn btn-sm btn-success mb-2 me-2">Add User</a>
<div class="table-responsive">
<table class="table table-striped table-hover" aria-label="User list">
    <thead>
        <tr>
            <th scope="col">First Name</th>
            <th scope="col">Last Name</th>
            <th scope="col">Username</th>
            <th scope="col">Role</th>
            <th scope="col">Actions</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let user of users">
            <td>{{user.firstName}}</td>
            <td>{{user.lastName}}</td>
            <td>{{user.username}}</td>
            <td>{{user.role}}</td>
            <td style="white-space: nowrap">
                <a routerLink="edit/{{user.id}}" class="btn btn-sm btn-primary me-1" [attr.aria-label]="'Edit user ' + user.firstName">Edit</a>
                <button (click)="deleteUser(user.id)" class="btn btn-sm btn-danger btn-delete-user btn-sm" [disabled]="user.isDeleting" [attr.aria-label]="'Delete user ' + user.firstName">
                    <span *ngIf="user.isDeleting" class="spinner-border spinner-border-sm"></span>
                    <span *ngIf="!user.isDeleting">Delete</span>
                </button>
            </td>
        </tr>
        <tr *ngIf="isLoading">
            <td colspan="5" class="text-center">
                <span class="spinner-border spinner-border-lg align-center"></span>
            </td>
        </tr>
        <tr *ngIf="!isLoading && (!users || users.length === 0)">
            <td colspan="5" class="text-center py-4 text-muted">
                <i class="fa fa-inbox fa-2x d-block mb-2"></i>
                No records found.
            </td>
        </tr>
    </tbody>
</table>
</div>
</div>